import React from 'react';
import ConfirmDeleteContractOwnershipDialog from 'src/components/project/sections/LeasingComponents/redesign/ConfirmDeleteDialog';
import AddOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddOwnership';
import AddWIOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddWIOwnership';
import AddContractOwnershipDialog from 'src/components/project/sections/LeasingComponents/redesign/AddContractOwnershipDialog';
import OwnershipContactCategoryForm from 'src/models/OwnershipContactCategoryForm';
import ContractGenerationOwnerData from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationOwnerData';
import ManageAgreementDialog from 'src/components/project/sections/TractComponents/ManageAgreementDialog.redesign';
import Owner from 'src/models/tract_detail/Owner';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import IContract from 'src/models/contract_types/IContract';
import ContractContactCategoryDialog from 'src/components/project/sections/LeasingComponents/ContractContactCategoryDialog';
import RevokeContractInhandDialog from 'src/components/project/sections/LeasingComponents/redesign/ConfirmRevokeContractInHandDialog';
import ConfirmDecommitContractDialog from 'src/components/project/sections/LeasingComponents/redesign/ConfirmDecommitContractDialog';
import EntityChangeLogDialog from 'src/components/project/sections/LeasingComponents/EntityModificationComponents/EntityChangeLogDialog';
import EntityModificationContract from 'src/models/entityModificationLogs/EntityModificationContract';
import LandContractType from 'src/models/LandContractType';
import EmailLeaseBuyersDialog from 'src/components/project/sections/LeasingComponents/EmailLeaseBuyersDialog';
import OwnershipLeaseBuyer from 'src/models/OwnershipLeaseBuyer';

export type dialogCreator = {
    deleteContractOwnership: (entityName: string, confirmDelete: () => void, cancelDelete: () => void) => void;
    deCommitContract: (
        entityName: string,
        ownerData: LeaseGenerationOwnerData | ContractGenerationOwnerData,
        contractData: IContract,
        commitListener: (data: boolean) => void,
        confirmDecommit: () => void,
        cancelDecommit: () => void
    ) => void;
    addContractOwnership: (
        dialogName: string,
        title: string,
        horizon: number,
        parentOwnershipId: number,
        clientNumber: number,
        projectNumber: number,
        pageNumber: number,
        navigate: (path: string) => void,
        saveAddTractOwnership: (values: AddOwnershipData) => void,
        saveAddContractOwnership: (values: AddWIOwnershipData) => void
    ) => void;
    selectContractCommittedStatus: (
        contactCategory: OwnershipContactCategoryForm,
        ownerData: LeaseGenerationOwnerData | ContractGenerationOwnerData,
        contractData: IContract,
        commitListener: (data: boolean) => void,
        hideDialog: () => void
    ) => void;
    addManageAgreement: (clientNumber: number, projectNumber: number, ownerLookupId: number, hideDialog: () => void, selectedOwner: Owner) => void;
    revokeInhandContractStatus: (
        contractType: LandContractType,
        entityName: string,
        commitListener: (data: boolean) => void,
        confirmRevokeInhand: () => void,
        cancelRevokeInhand: () => void
    ) => void;
    getChangeLog: (
        entityType: string,
        entityId: number,
        changeLogs: EntityModificationContract
    ) => void;
    emailLeaseBuyers: (
        leaseBuyerList: OwnershipLeaseBuyer[],
        onSave: () => void   
    ) => void;
};

const creators = (setDialog: (element: React.ReactElement) => void): dialogCreator => {
    return {
        deleteContractOwnership: (entityName: string, confirmDelete: () => void, cancelDelete: () => void) => {
            setDialog(
                React.createElement(ConfirmDeleteContractOwnershipDialog, {
                    entityName: entityName,
                    confirmDelete: confirmDelete,
                    cancelDelete: cancelDelete,
                })
            );
        },
        deCommitContract: (
            entityName: string,
            ownerData: LeaseGenerationOwnerData | ContractGenerationOwnerData,
            contractData: IContract,
            commitListener: (data: boolean) => void,
            confirmDecommit: () => void,
            cancelDecommit: () => void) => {
            setDialog(
                React.createElement(ConfirmDecommitContractDialog, {
                    entityName: entityName,
                    ownerData,
                    contractData,
                    commitListener,
                    confirmDecommit: confirmDecommit,
                    cancelDecommit: cancelDecommit
                })
            );
        },
        addContractOwnership: (
            dialogName: string,
            title: string,
            horizon: number,
            parentOwnershipId: number,
            clientNumber: number,
            projectNumber: number,
            pageNumber: number,
            navigate: (path: string) => void,
            saveAddTractOwnership: (values: AddOwnershipData) => void,
            saveAddContractOwnership: (values: AddWIOwnershipData) => void
        ) => {
            setDialog(
                React.createElement(AddContractOwnershipDialog, {
                    dialogName: dialogName,
                    title: title,
                    horizon: horizon,
                    parentOwnershipId: parentOwnershipId,
                    clientNumber: clientNumber,
                    projectNumber: projectNumber,
                    pageNumber: pageNumber,
                    navigate: navigate,
                    saveAddTractOwnership: saveAddTractOwnership,
                    saveAddContractOwnership: saveAddContractOwnership,
                })
            );
        },
        selectContractCommittedStatus(
            contactCategory: OwnershipContactCategoryForm,
            ownerData: LeaseGenerationOwnerData | ContractGenerationOwnerData,
            contractData: IContract,
            commitListener: (data: boolean) => void,
            hideDialog: () => void
        ) {
            setDialog(React.createElement(ContractContactCategoryDialog, { contactCategory, ownerData, contractData, commitListener, hideDialog }));
        },
        addManageAgreement(clientNumber: number, projectNumber: number, ownerLookupId: number, hideDialog: () => void, selectedOwner: Owner) {
            setDialog(
                React.createElement(ManageAgreementDialog, {
                    clientNumber,
                    projectNumber,
                    ownerLookupId,
                    hideDialog,
                    selectedOwner,
                })
            );
        },
        revokeInhandContractStatus: (
            contractType: LandContractType,
            entityName: string,
            commitListener: (data: boolean) => void,
            confirmRevokeInhand: () => void,
            cancelRevokeInhand: () => void) => {
            setDialog(
                React.createElement(RevokeContractInhandDialog, {
                    contractType: contractType,
                    entityName: entityName,
                    commitListener,
                    confirmRevokeInhand: confirmRevokeInhand,
                    cancelRevokeInhand: cancelRevokeInhand
                })
            );
        },
        getChangeLog(entityType: string, entityId: number, changeLogs: EntityModificationContract) {
            setDialog(
                React.createElement(EntityChangeLogDialog, {
                    entityType,
                    entityId,
                    changeLogs
                })
            );
        },
        emailLeaseBuyers(
            leaseBuyerList: OwnershipLeaseBuyer[], 
            onSave: () => void) {
                setDialog(
                    React.createElement(EmailLeaseBuyersDialog, {
                        leaseBuyerList,
                        onSave
                    })
                );
        }
    };
};

export default creators;



// WEBPACK FOOTER //
// ./src/providers/dialogs/contract.ts